<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!acompanhamentosOperacao || !acompanhamentosOperacao.length">
        Não foi encontrada posição da carteira em recuperação de crédito com os filtros informados.
    </div>

    <div *ngIf="acompanhamentosOperacao && acompanhamentosOperacao.length">
        <div *ngIf="dataHoraResultado" class="float-start letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th *ngIf="!ehAgenteFinanceiro" id="col-agente" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'agenteFinanceiroDestinatario'"
                                    [nomeAtributoExibicao]="'Agente financeiro'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                        
                            <th id="col-idOperacaoExterno" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'idOperacaoExterno'" 
                                    [nomeAtributoExibicao]="'Id. externo operação:'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-sistema-contrato" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'contrato'" 
                                    [nomeAtributoExibicao]="'Sist/Contrato'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-status" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'statusProtocolo'" 
                                    [nomeAtributoExibicao]="'Status Protocolo'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>  

                            <th id="col-dataEnvio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataEnvio'" 
                                    [nomeAtributoExibicao]="'Janela'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>  

                            <th id="col-encerrado" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'encerrado'" 
                                    [nomeAtributoExibicao]="'Cobranca Encerrada'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            
                            <th scope="col" class="text-start">
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let acompanhamentoOperacao of acompanhamentosOperacao" id="pointer" [routerLink]="['/acompanhamento-processual/', acompanhamentoOperacao.id]">
                            <td *ngIf="!ehAgenteFinanceiro">{{ nomeAgenteFinanceiro(acompanhamentoOperacao.cnpjAgenteFinanceiro) }}</td>
                            <td>{{ acompanhamentoOperacao.idOperacaoAgente }}</td>
                            <td>{{ acompanhamentoOperacao.contratoCobranca ? acompanhamentoOperacao.sistemaCobranca + '/' + acompanhamentoOperacao.contratoCobranca : ''}}</td>
                            <td>{{ nomeStatusProtocolo(acompanhamentoOperacao.statusProtocolo) }}</td>
                            <td>{{ acompanhamentoOperacao.dataEnvio | date: 'yyyy'}}</td>
                            <td>{{ acompanhamentoOperacao.cobrancaEncerrada=='S' ? 'Sim' : 'Não' }}</td>
                           
                        </tr>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>